import {UnsupportedType} from '../UnsupportedType'
import {BlockAccordion} from './Accordion/BlockAccordion'
import {BlockAppDownload} from './BlockAppDownload'
import {BlockAutoplayType} from './BlockAutoplayType'
import {BlockBanner} from './BlockBanner'
import {BlockMediaComparisonSlider} from './BlockMediaComparisonSlider'
import {BlockMediaGallery} from './BlockMediaGallery'
import {BlockMediaSingleImageType} from './BlockMediaSingleImageType'
import {BlockHighlight} from './BlockHighlight'
import {BlockRichText} from './BlockRichText'
import {BlockVehicleDataTable} from './BlockVehicleDataTable'
import {BlockVideoType} from './BlockVideoType'
import {BlockVideoWithDescriptionType} from './BlockVideoWithDescriptionType'
import {BlockExternalLink} from './BlockExternalLink'
import {BlockConsumptionValues} from './BlockConsumptionValues'
import {BlockPricingTable} from './BlockPricingTable'
import {BlockQuotes} from './BlockQuotes'
import {BlockAwardRow, BlockButtonRow, BlockKeyFactRow, BlockKeyFactSmallRow, BlockKpiRow} from './Rows'
import {BlockKeyValueTable} from './BlockKeyValueTable'
import {BlockDocumentHeader} from './BlockDocumentHeader'
import {BlockSePrice} from './BlockSePrice'
import {BlockSeEek} from './BlockSeEek'
import {BlockSeQualityDescription} from './BlockSeQualityDescription'
import {BlockSeFeatureImages} from './BlockSeFeatureImages'
import {BlockPdfPreview} from './BlockPdfPreview'
import {BlockIntegration} from './BlockIntegration'
import {BlockInstagram} from './BlockInstagram'
import {BlockChapterOpener} from './BlockChapterOpener'
import {BlockDivider} from './BlockDivider'
import {BlockDataSheetType} from './BlockDataSheetType'
import {BlockErrorType} from './BlockErrorType'
import {BlockDealerStamp} from './BlockDealerStamp'

import type {XcNwBlockFragment} from '@sdox/api'

export const BlockMapper = (props: XcNwBlockFragment) => {
  if (props.__typename === 'BlockJsonType') return null
  if (props.__typename === 'BlockDocumentHeaderType') return <BlockDocumentHeader {...props} />
  if (props.__typename === 'BlockMediaGalleryType') return <BlockMediaGallery {...props} />
  if (props.__typename === 'BlockMediaComparisonSliderType') return <BlockMediaComparisonSlider {...props} />
  if (props.__typename === 'BlockHighlightType') return <BlockHighlight {...props} />
  if (props.__typename === 'BlockAutoplayType') return <BlockAutoplayType {...props} />
  if (props.__typename === 'BlockVideoType') return <BlockVideoType {...props} />
  if (props.__typename === 'BlockVideoWithDescriptionType') return <BlockVideoWithDescriptionType {...props} />
  if (props.__typename === 'BlockAppDownloadType') return <BlockAppDownload {...props} />
  if (props.__typename === 'BlockMediaSingleImageType') return <BlockMediaSingleImageType {...props} />
  if (props.__typename === 'BlockRichTextType') return <BlockRichText {...props} />
  if (props.__typename === 'BlockAccordionType') return <BlockAccordion {...props} />
  if (props.__typename === 'BlockBannerType') return <BlockBanner {...props} />
  if (props.__typename === 'BlockPricingTableType') return <BlockPricingTable {...props} />
  if (props.__typename === 'BlockExternalLinkType') return <BlockExternalLink {...props} />
  if (props.__typename === 'BlockKeyValueTableType') return <BlockKeyValueTable {...props} />
  if (props.__typename === 'BlockChapterOpenerType') return <BlockChapterOpener {...props} />
  if (props.__typename === 'BlockDataSheetType') return <BlockDataSheetType {...props} />
  if (props.__typename === 'BlockDividerType') return <BlockDivider {...props} />
  // Rows
  if (props.__typename === 'AwardTypeBlockRowType') return <BlockAwardRow {...props} />
  if (props.__typename === 'ButtonTypeBlockRowType') return <BlockButtonRow {...props} />
  if (props.__typename === 'ConsumptionValueTypeBlockRowType') return <BlockConsumptionValues {...props} />
  if (props.__typename === 'KpiTypeBlockRowType') return <BlockKpiRow {...props} />
  if (props.__typename === 'KeyFactTypeBlockRowType') return <BlockKeyFactRow {...props} />
  if (props.__typename === 'KeyFactSmallBlockRowType') return <BlockKeyFactSmallRow {...props} />
  if (props.__typename === 'VehicleDataTableSectionTypeBlockRowType') return <BlockVehicleDataTable {...props} />
  // special
  if (props.__typename === 'BlockQuotesType') return <BlockQuotes {...props} />
  if (props.__typename === 'BlockInstagramType') return <BlockInstagram {...props} />
  if (props.__typename === 'BlockErrorType') return <BlockErrorType {...props} />
  // SE legacy
  if (props.__typename === 'BlockSePriceType') return <BlockSePrice {...props} />
  if (props.__typename === 'BlockSeEekType') return <BlockSeEek {...props} />
  if (props.__typename === 'BlockSeQualityDescriptionType') return <BlockSeQualityDescription {...props} />
  if (props.__typename === 'BlockSeFeatureImagesType') return <BlockSeFeatureImages {...props} />
  // Fancy file upload stuff
  if (props.__typename === 'BlockPdfPreviewType') return <BlockPdfPreview {...props} />
  // Integrations
  if (props.__typename === 'BlockIntegrationType') return <BlockIntegration {...props} />
  if (props.__typename === 'BlockOfficeVCardType') return <BlockDealerStamp {...props} />

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore this should never happen!
  return <UnsupportedType __typename={props.__typename} />
}
